import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getAcastEpisode } from "../../helper/api";
import { PodcastPodcatcherSubscribeList } from "../podcast-podcatcher-subscribe-list";
import DownloadButton from "../../download-button";
import { IS_OPEN_LOGIN_FORM } from "../../helper/actions";
import { getGlobalPlayerRef } from "../../podcast-player/utils";
import { PauseButton, PlayButton } from "../../podcast-player/icons";
import { parseUrl } from "query-string";
import get from "lodash/get";
import assetify from "@quintype/framework/assetify";
import applePodcasts from "../../../../assets/images/apple_podcasts.svg";
import googlePodcasts from "../../../../assets/images/google_podcasts.svg";
import spotifyIcon from "../../../../assets/images/spotify_podcasts.svg";
import overcastIcon from "../../../../assets/images/overcast_podcasts.svg";
import rssIcon from "../../../../assets/images/rss_podcasts.svg";
import castboxIcon from "../../../../assets/images/castbox.svg";
import stitcher from "../../../../assets/images/stitcher.png";
import { Loader } from "../../podcast-player/Loader";
import { useDispatch, useSelector } from "react-redux";

import "./episode-play-button.m.css";

export function EpisodePlayButton(props) {

  const [track, setTrack] = useState({});
  const [playerState, setPlayerState] = useState({});
  const [error, setError] = useState(false)


  const member = useSelector(state => state.member);
  const authHost= useSelector(state => get(state,["qt", "config", "publisher", "publisher", "auth_host"], null));
  const currentPath = useSelector(state => get(state, ["qt", "currentPath"], ""));
  const params = parseUrl(currentPath);
  const callbackUrl = get(params, ["query", "callback-url"], global.location && global.location.origin);
  const redirectUrl = get(params, ["query", "redirect-url"], global && global.location && global.location.href);
  const url =`${authHost}/authenticate?redirect-url=${redirectUrl}&callback-url=${callbackUrl}&auth-page=${authHost}/user-login`;
  
  

  useEffect(() => {
    const playerRef = getGlobalPlayerRef();
    const removeListener = playerRef.addPlayerListener(state => {
      setPlayerState(state);
    });

    async function getAndLoadEpisode() {
      // eslint-disable-next-line camelcase
      const { episode_id, show_id } = props.data;
      const data = await getAcastEpisode(show_id, episode_id);
      setTrack(data.episode);
    }

    getAndLoadEpisode();

    return removeListener;
  }, []);

  const isLoading =(playerState.audioStatus === "loading" && playerState.currentTrackId === track._id) || playerState.loadingUserQueue;
  const isPlaying = playerState.audioStatus === "playing" && playerState.currentTrackId === track._id;
  const isLoaded = playerState.currentTrackId === track._id;
  const dispatch = useDispatch();

  const playEpisode = async () => {
    const playerRef = getGlobalPlayerRef();
    if (isPlaying) {
      playerRef.pause();
    } else if (isLoaded) {
      playerRef.play();
    } else {
      playerRef.playTrack({ ...track, podcast: {} });
      playerRef.setState({ showPlayer: true });
    }
  };

  const handleClick = () => {
    member?
      playEpisode()
    :
      setError(true)
  }

  const redirectToLogin = () => {
    window.location=url
  };

  const renderPlayButton = episode => {
    return(
      <div styleName="play-button-wrapper" onClick={handleClick}>
        <div styleName="icon-wrapper">
          {!isLoading?
            <React.Fragment>
              <i className="material-icons-outlined" >
                {!isPlaying? "play_circle": "pause_circle"}
              </i>
              <p>{isPlaying?"Pause":"Play"}</p>
            </React.Fragment>
          :
            <button aria-label="loading" title="Loading" className="pressable" aria-disabled={true}>
              <Loader />
            </button>
          }
        </div>
      </div>
    )
  }
  
  return (
    <div styleName="button-wrapper">
      {track && (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div styleName = "thumbnail">
                <img src={track.cover} alt ={track.show}/>
            </div>
      
            <div styleName="track-meta">
              {error && 
                <p styleName="error">
                  <a onClick={redirectToLogin}>
                    Login
                  </a>&nbsp; 
                  to access our feature-laden podcast player for free
                </p>
              }

              <div styleName="track-title">{track.title}</div>
              
              <div styleName="track-actions">
                {renderPlayButton()}
                  {track.show && <PodcastPodcatcherSubscribeList
                    showId={track.show.toString()}
                    show={true}
                    onClose={() => setShowSubscribeModal(false)}
                  />}
              </div>
            </div> 
          </div>
      )}
    </div>
  );
}

EpisodePlayButton.propTypes = {
  data: PropTypes.object
};
